import ApiAccess from "./ApiAccess";

export default ApiAccess;